import { defineComponent as _defineComponent } from 'vue'
import { dateAndTimeFormat } from '@/composables/useFilters';

interface Props {
  icon?: string
  date?: string
  userName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FpMessageWrapper',
  props: {
    icon: null,
    date: null,
    userName: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string
  date?: string
  userName?: string
};



const formatDate = (date: string) => {
  if (!date) return ''
  return dateAndTimeFormat(date)
}

return { __sfc: true,props, formatDate }
}

})